import React, { Fragment, useEffect } from 'react';
import { find } from 'lodash-es';

import { SelectProps } from '@material-ui/core/Select';
import Grid, { GridSize } from '@material-ui/core/Grid';

import Button from '../../../../../src/components/controls/button/button';
import DatePicker from '../../../../../src/components/controls/date-picker/date-picker';
import { AcceptableValue } from '../editable-user-data';
import { useTrans } from '@/custom-hooks/useTrans';

export type FactoryDateRangePickerValues = { id: string; value: string }; //Record<string, { id: string; value: string }>;

import styles from './factory-date-range-picker.module.scss';

function dateStringToNumber(dateString?: string) {
    if (!dateString) return 0;
    return parseInt(dateString.split('-').join(''), 10);
}

type FactoryDateRangePickerProps = SelectProps & {
    id: string;
    fieldKey: string;
    values: FactoryDateRangePickerValues[];
    gridColumnSpan: GridSize;
    dictionaryBase?: string;
    onChangeOverride: (id: string, val?: AcceptableValue) => void;
    fieldConfig: any;
};
export default function FactoryDateRangePicker(props: FactoryDateRangePickerProps) {
    const { t } = useTrans();
    const { values, fieldKey, gridColumnSpan, dictionaryBase, onChangeOverride, fieldConfig } =
        props;
    const { format, clearable = [false, false], fieldIds } = fieldConfig;
    const formLabelBase = `${dictionaryBase}.formLabels`;

    const startDateFromBackend = find(values, (val) => val.id === 'startDate')?.value;
    const endDate = find(values, (val) => val.id === 'endDate')?.value;

    const startDate = startDateFromBackend === '1900-01-01' ? undefined : startDateFromBackend;
    const endDateBeforeStartDate = dateStringToNumber(startDate) > dateStringToNumber(endDate);

    useEffect(() => {
        if (startDate === undefined) {
            onChangeOverride?.('startDate', '1900-01-01');
        }

        if (endDateBeforeStartDate) {
            onChangeOverride?.('endDate', null);
        }
    }, [endDateBeforeStartDate]);

    return (
        <Fragment key={fieldKey}>
            <Grid
                key={`${fieldKey}|COUNTRY`}
                item
                xs={gridColumnSpan}
                className={styles.dateRangePicker}
            >
                <DatePicker
                    format={format}
                    label={t(`${formLabelBase}.${fieldIds[0]}.label`)}
                    placeHolder={
                        !startDate
                            ? t(`${formLabelBase}.startDate.placeHolder`)
                            : (t('labels.select', {
                                  AK_TAG_THING_TO_SELECT: t(
                                      `${formLabelBase}.${fieldIds[1]}.label`
                                  ),
                              }) as string)
                    }
                    initDate={startDate}
                    clearable={clearable[0]}
                    onChange={(newDate: AcceptableValue) => {
                        onChangeOverride &&
                            onChangeOverride('startDate', newDate?.toString().split('T')[0]);
                    }}
                />
            </Grid>
            <Grid
                key={`${fieldKey}|REGION`}
                item
                xs={gridColumnSpan}
                className={styles.dateRangePicker}
            >
                {startDate ? (
                    <DatePicker
                        format={format}
                        label={t(`${formLabelBase}.${fieldIds[1]}.label`)}
                        placeHolder={
                            !endDate
                                ? t(`${formLabelBase}.endDate.selectStartDate`)
                                : (t('labels.select', {
                                      AK_TAG_THING_TO_SELECT: t(
                                          `${formLabelBase}.${fieldIds[1]}.label`
                                      ),
                                  }) as string)
                        }
                        initDate={endDate}
                        minDate={startDate}
                        clearable={clearable[1]}
                        onChange={(newDate: AcceptableValue) => {
                            onChangeOverride &&
                                onChangeOverride('endDate', newDate?.toString().split('T')[0]);
                        }}
                    />
                ) : (
                    <Button
                        style={{ width: '100%' }}
                        size='small'
                        disabled
                        label={t(`${formLabelBase}.endDate.selectStartDate`)}
                        variant='outlined'
                    />
                )}
            </Grid>
        </Fragment>
    );
}
